//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class BankClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Banks
     * @return The list of Banks
     */
    getBanks( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/bank";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBanks(_response);
        });
    }

    protected processGetBanks(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Bank
     * @param body The Bank data to create
     * @return The newly created Bank data
     */
    createBank(body: BankDTO, cancelToken?: CancelToken): Promise<ApiResponse_bankDTO> {
        let url_ = this.baseUrl + "/bank";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBank(_response);
        });
    }

    protected processCreateBank(response: AxiosResponse): Promise<ApiResponse_bankDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_bankDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bankDTO>(null as any);
    }

    /**
     * Retrieve a Bank by ID
     * @param id The ID of the Bank to retrieve
     * @return The Bank data
     */
    getBankById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_bankDTO> {
        let url_ = this.baseUrl + "/bank/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBankById(_response);
        });
    }

    protected processGetBankById(response: AxiosResponse): Promise<ApiResponse_bankDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_bankDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bankDTO>(null as any);
    }

    /**
     * Update a Bank by ID
     * @param id The ID of the Bank to update
     * @param body The updated Bank data
     * @return The updated Bank data
     */
    updateBank(id: string, body: BankDTO, cancelToken?: CancelToken): Promise<ApiResponse_bankDTO> {
        let url_ = this.baseUrl + "/bank/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBank(_response);
        });
    }

    protected processUpdateBank(response: AxiosResponse): Promise<ApiResponse_bankDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_bankDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bankDTO>(null as any);
    }

    /**
     * Delete a Bank by ID
     * @param id The ID of the Bank to delete
     */
    deleteBank(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/bank/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBank(_response);
        });
    }

    protected processDeleteBank(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Banks based on criteria
     * @param body The search criteria
     * @return The search results of Banks based on the criteria
     */
    searchBanks(body: SearchRequestDTO_bankSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/bank/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchBanks(_response);
        });
    }

    protected processSearchBanks(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class BatchFileLogClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all BatchFileLogs
     * @return The list of BatchFileLogs
     */
    getBatchFileLogs( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/batchfilelog";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBatchFileLogs(_response);
        });
    }

    protected processGetBatchFileLogs(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new BatchFileLog
     * @param body The BatchFileLog data to create
     * @return The newly created BatchFileLog data
     */
    createBatchFileLog(body: BatchFileLogDTO, cancelToken?: CancelToken): Promise<ApiResponse_batchFileLogDTO> {
        let url_ = this.baseUrl + "/batchfilelog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBatchFileLog(_response);
        });
    }

    protected processCreateBatchFileLog(response: AxiosResponse): Promise<ApiResponse_batchFileLogDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_batchFileLogDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_batchFileLogDTO>(null as any);
    }

    /**
     * Retrieve a BatchFileLog by ID
     * @param id The ID of the BatchFileLog to retrieve
     * @return The BatchFileLog data
     */
    getBatchFileLogById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_batchFileLogDTO> {
        let url_ = this.baseUrl + "/batchfilelog/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBatchFileLogById(_response);
        });
    }

    protected processGetBatchFileLogById(response: AxiosResponse): Promise<ApiResponse_batchFileLogDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_batchFileLogDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_batchFileLogDTO>(null as any);
    }

    /**
     * Update a BatchFileLog by ID
     * @param id The ID of the BatchFileLog to update
     * @param body The updated BatchFileLog data
     * @return The updated BatchFileLog data
     */
    updateBatchFileLog(id: string, body: BatchFileLogDTO, cancelToken?: CancelToken): Promise<ApiResponse_batchFileLogDTO> {
        let url_ = this.baseUrl + "/batchfilelog/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBatchFileLog(_response);
        });
    }

    protected processUpdateBatchFileLog(response: AxiosResponse): Promise<ApiResponse_batchFileLogDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_batchFileLogDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_batchFileLogDTO>(null as any);
    }

    /**
     * Delete a BatchFileLog by ID
     * @param id The ID of the BatchFileLog to delete
     */
    deleteBatchFileLog(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/batchfilelog/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBatchFileLog(_response);
        });
    }

    protected processDeleteBatchFileLog(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search BatchFileLogs based on criteria
     * @param body The search criteria
     * @return The search results of BatchFileLogs based on the criteria
     */
    searchBatchFileLogs(body: SearchRequestDTO_batchFileLogSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/batchfilelog/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchBatchFileLogs(_response);
        });
    }

    protected processSearchBatchFileLogs(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Checks batch file status
     * @param batchNumber The batch number to check.
     * @return The batch file status response
     */
    checkBatchFile(batchNumber: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/batchfilelog/check-batch?";
        if (batchNumber === undefined || batchNumber === null)
            throw new Error("The parameter 'batchNumber' must be defined and cannot be null.");
        else
            url_ += "batchNumber=" + encodeURIComponent("" + batchNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckBatchFile(_response);
        });
    }

    protected processCheckBatchFile(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class CampaignClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Campaigns
     * @return The list of Campaigns
     */
    getCampaigns( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/campaign";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCampaigns(_response);
        });
    }

    protected processGetCampaigns(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Campaign
     * @param body The Campaign data to create
     * @return The newly created Campaign data
     */
    createCampaign(body: CampaignDTO, cancelToken?: CancelToken): Promise<ApiResponse_campaignDTO> {
        let url_ = this.baseUrl + "/campaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCampaign(_response);
        });
    }

    protected processCreateCampaign(response: AxiosResponse): Promise<ApiResponse_campaignDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_campaignDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_campaignDTO>(null as any);
    }

    /**
     * Retrieve a Campaign by ID
     * @param id The ID of the Campaign to retrieve
     * @return The Campaign data
     */
    getCampaignById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_campaignDTO> {
        let url_ = this.baseUrl + "/campaign/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCampaignById(_response);
        });
    }

    protected processGetCampaignById(response: AxiosResponse): Promise<ApiResponse_campaignDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_campaignDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_campaignDTO>(null as any);
    }

    /**
     * Update a Campaign by ID
     * @param id The ID of the Campaign to update
     * @param body The updated Campaign data
     * @return The updated Campaign data
     */
    updateCampaign(id: string, body: CampaignDTO, cancelToken?: CancelToken): Promise<ApiResponse_campaignDTO> {
        let url_ = this.baseUrl + "/campaign/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCampaign(_response);
        });
    }

    protected processUpdateCampaign(response: AxiosResponse): Promise<ApiResponse_campaignDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_campaignDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_campaignDTO>(null as any);
    }

    /**
     * Delete a Campaign by ID
     * @param id The ID of the Campaign to delete
     */
    deleteCampaign(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/campaign/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCampaign(_response);
        });
    }

    protected processDeleteCampaign(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Campaigns based on criteria
     * @param body The search criteria
     * @return The search results of Campaigns based on the criteria
     */
    searchCampaigns(body: SearchRequestDTO_campaignSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/campaign/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCampaigns(_response);
        });
    }

    protected processSearchCampaigns(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Uploads a background image for a campaign.
     * @param fileName (optional) The file name to use when saving the image
     * @param body The raw image file to upload
     * @return The URL of the uploaded image
     */
    uploadCampaignImage(fileName: string | null | undefined, body: Blob, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/campaign/upload-image?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/octet-stream",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadCampaignImage(_response);
        });
    }

    protected processUploadCampaignImage(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generates a SAS token for a campaign background image.
     * @param id The ID of the campaign.
     * @return The SAS URL for the campaign image.
     */
    generateCampaignImageSas(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/campaign/{id}/image";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateCampaignImageSas(_response);
        });
    }

    protected processGenerateCampaignImageSas(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class DebitOrderMandateClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Uploads a debit order mandate.
     * @param id The ID of the campaign.
     * @param body (optional) The Campaign data to create
     * @return The URL of the uploaded mandate
     */
    uploadDebitOrderMandate(id: string, body: DebitOrderMandateDTO | null | undefined, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/campaign/upload-debit-order-mandate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadDebitOrderMandate(_response);
        });
    }

    protected processUploadDebitOrderMandate(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class DonationOptionClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all DonationOptions
     * @return The list of DonationOptions
     */
    getDonationOptions( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/donationoption";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDonationOptions(_response);
        });
    }

    protected processGetDonationOptions(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new DonationOption
     * @param body The DonationOption data to create
     * @return The newly created DonationOption data
     */
    createDonationOption(body: DonationOptionDTO, cancelToken?: CancelToken): Promise<ApiResponse_donationOptionDTO> {
        let url_ = this.baseUrl + "/donationoption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDonationOption(_response);
        });
    }

    protected processCreateDonationOption(response: AxiosResponse): Promise<ApiResponse_donationOptionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_donationOptionDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_donationOptionDTO>(null as any);
    }

    /**
     * Retrieve a DonationOption by ID
     * @param id The ID of the DonationOption to retrieve
     * @return The DonationOption data
     */
    getDonationOptionById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_donationOptionDTO> {
        let url_ = this.baseUrl + "/donationoption/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDonationOptionById(_response);
        });
    }

    protected processGetDonationOptionById(response: AxiosResponse): Promise<ApiResponse_donationOptionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_donationOptionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_donationOptionDTO>(null as any);
    }

    /**
     * Update a DonationOption by ID
     * @param id The ID of the DonationOption to update
     * @param body The updated DonationOption data
     * @return The updated DonationOption data
     */
    updateDonationOption(id: string, body: DonationOptionDTO, cancelToken?: CancelToken): Promise<ApiResponse_donationOptionDTO> {
        let url_ = this.baseUrl + "/donationoption/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDonationOption(_response);
        });
    }

    protected processUpdateDonationOption(response: AxiosResponse): Promise<ApiResponse_donationOptionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_donationOptionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_donationOptionDTO>(null as any);
    }

    /**
     * Delete a DonationOption by ID
     * @param id The ID of the DonationOption to delete
     */
    deleteDonationOption(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/donationoption/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDonationOption(_response);
        });
    }

    protected processDeleteDonationOption(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search DonationOptions based on criteria
     * @param body The search criteria
     * @return The search results of DonationOptions based on the criteria
     */
    searchDonationOptions(body: SearchRequestDTO_donationOptionSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/donationoption/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchDonationOptions(_response);
        });
    }

    protected processSearchDonationOptions(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class FileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Uploads a file to blob storage
     * @param containerName The container name to upload to
     * @param fileName (optional) Optional file name to use
     * @param folder (optional) Optional folder path within container
     * @param body The file content to upload
     * @return The URL of the uploaded file
     */
    uploadFile(containerName: string, fileName: string | null | undefined, folder: string | null | undefined, body: Blob, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/file/{containerName}/upload?";
        if (containerName === undefined || containerName === null)
            throw new Error("The parameter 'containerName' must be defined.");
        url_ = url_.replace("{containerName}", encodeURIComponent("" + containerName));
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (folder !== undefined && folder !== null)
            url_ += "folder=" + encodeURIComponent("" + folder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/octet-stream",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFile(_response);
        });
    }

    protected processUploadFile(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Gets a file's SAS URL
     * @param containerName The container name where the file is stored
     * @param filePath The relative path to the file
     * @return The SAS URL for the file
     */
    getFileUrl(containerName: string, filePath: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/file/{containerName}/{filePath}";
        if (containerName === undefined || containerName === null)
            throw new Error("The parameter 'containerName' must be defined.");
        url_ = url_.replace("{containerName}", encodeURIComponent("" + containerName));
        if (filePath === undefined || filePath === null)
            throw new Error("The parameter 'filePath' must be defined.");
        url_ = url_.replace("{filePath}", encodeURIComponent("" + filePath));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileUrl(_response);
        });
    }

    protected processGetFileUrl(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class PaymentClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Payments
     * @return The list of Payments
     */
    getPayments( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/payment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPayments(_response);
        });
    }

    protected processGetPayments(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Payment
     * @param body The Payment data to create
     * @return The newly created Payment data
     */
    createPayment(body: PaymentDTO, cancelToken?: CancelToken): Promise<ApiResponse_paymentDTO> {
        let url_ = this.baseUrl + "/payment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePayment(_response);
        });
    }

    protected processCreatePayment(response: AxiosResponse): Promise<ApiResponse_paymentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_paymentDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_paymentDTO>(null as any);
    }

    /**
     * Retrieve a Payment by ID
     * @param id The ID of the Payment to retrieve
     * @return The Payment data
     */
    getPaymentById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_paymentDTO> {
        let url_ = this.baseUrl + "/payment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentById(_response);
        });
    }

    protected processGetPaymentById(response: AxiosResponse): Promise<ApiResponse_paymentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_paymentDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_paymentDTO>(null as any);
    }

    /**
     * Update a Payment by ID
     * @param id The ID of the Payment to update
     * @param body The updated Payment data
     * @return The updated Payment data
     */
    updatePayment(id: string, body: PaymentDTO, cancelToken?: CancelToken): Promise<ApiResponse_paymentDTO> {
        let url_ = this.baseUrl + "/payment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePayment(_response);
        });
    }

    protected processUpdatePayment(response: AxiosResponse): Promise<ApiResponse_paymentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_paymentDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_paymentDTO>(null as any);
    }

    /**
     * Delete a Payment by ID
     * @param id The ID of the Payment to delete
     */
    deletePayment(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/payment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePayment(_response);
        });
    }

    protected processDeletePayment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Payments based on criteria
     * @param body The search criteria
     * @return The search results of Payments based on the criteria
     */
    searchPayments(body: SearchRequestDTO_paymentSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/payment/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchPayments(_response);
        });
    }

    protected processSearchPayments(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class PaymentResponseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all PaymentResponses
     * @return The list of PaymentResponses
     */
    getPaymentResponses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/paymentresponse";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentResponses(_response);
        });
    }

    protected processGetPaymentResponses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new PaymentResponse
     * @param body The PaymentResponse data to create
     * @return The newly created PaymentResponse data
     */
    createPaymentResponse(body: PaymentResponseDTO, cancelToken?: CancelToken): Promise<ApiResponse_paymentResponseDTO> {
        let url_ = this.baseUrl + "/paymentresponse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePaymentResponse(_response);
        });
    }

    protected processCreatePaymentResponse(response: AxiosResponse): Promise<ApiResponse_paymentResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_paymentResponseDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_paymentResponseDTO>(null as any);
    }

    /**
     * Retrieve a PaymentResponse by ID
     * @param id The ID of the PaymentResponse to retrieve
     * @return The PaymentResponse data
     */
    getPaymentResponseById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_paymentResponseDTO> {
        let url_ = this.baseUrl + "/paymentresponse/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentResponseById(_response);
        });
    }

    protected processGetPaymentResponseById(response: AxiosResponse): Promise<ApiResponse_paymentResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_paymentResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_paymentResponseDTO>(null as any);
    }

    /**
     * Update a PaymentResponse by ID
     * @param id The ID of the PaymentResponse to update
     * @param body The updated PaymentResponse data
     * @return The updated PaymentResponse data
     */
    updatePaymentResponse(id: string, body: PaymentResponseDTO, cancelToken?: CancelToken): Promise<ApiResponse_paymentResponseDTO> {
        let url_ = this.baseUrl + "/paymentresponse/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePaymentResponse(_response);
        });
    }

    protected processUpdatePaymentResponse(response: AxiosResponse): Promise<ApiResponse_paymentResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_paymentResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_paymentResponseDTO>(null as any);
    }

    /**
     * Delete a PaymentResponse by ID
     * @param id The ID of the PaymentResponse to delete
     */
    deletePaymentResponse(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/paymentresponse/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePaymentResponse(_response);
        });
    }

    protected processDeletePaymentResponse(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search PaymentResponses based on criteria
     * @param body The search criteria
     * @return The search results of PaymentResponses based on the criteria
     */
    searchPaymentResponses(body: SearchRequestDTO_paymentResponseSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/paymentresponse/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchPaymentResponses(_response);
        });
    }

    protected processSearchPaymentResponses(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class PaymentResponseTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all PaymentResponseTypes
     * @return The list of PaymentResponseTypes
     */
    getPaymentResponseTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/paymentresponsetype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentResponseTypes(_response);
        });
    }

    protected processGetPaymentResponseTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new PaymentResponseType
     * @param body The PaymentResponseType data to create
     * @return The newly created PaymentResponseType data
     */
    createPaymentResponseType(body: PaymentResponseTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_paymentResponseTypeDTO> {
        let url_ = this.baseUrl + "/paymentresponsetype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePaymentResponseType(_response);
        });
    }

    protected processCreatePaymentResponseType(response: AxiosResponse): Promise<ApiResponse_paymentResponseTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_paymentResponseTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_paymentResponseTypeDTO>(null as any);
    }

    /**
     * Retrieve a PaymentResponseType by ID
     * @param id The ID of the PaymentResponseType to retrieve
     * @return The PaymentResponseType data
     */
    getPaymentResponseTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_paymentResponseTypeDTO> {
        let url_ = this.baseUrl + "/paymentresponsetype/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentResponseTypeById(_response);
        });
    }

    protected processGetPaymentResponseTypeById(response: AxiosResponse): Promise<ApiResponse_paymentResponseTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_paymentResponseTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_paymentResponseTypeDTO>(null as any);
    }

    /**
     * Update a PaymentResponseType by ID
     * @param id The ID of the PaymentResponseType to update
     * @param body The updated PaymentResponseType data
     * @return The updated PaymentResponseType data
     */
    updatePaymentResponseType(id: string, body: PaymentResponseTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_paymentResponseTypeDTO> {
        let url_ = this.baseUrl + "/paymentresponsetype/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePaymentResponseType(_response);
        });
    }

    protected processUpdatePaymentResponseType(response: AxiosResponse): Promise<ApiResponse_paymentResponseTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_paymentResponseTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_paymentResponseTypeDTO>(null as any);
    }

    /**
     * Delete a PaymentResponseType by ID
     * @param id The ID of the PaymentResponseType to delete
     */
    deletePaymentResponseType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/paymentresponsetype/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePaymentResponseType(_response);
        });
    }

    protected processDeletePaymentResponseType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search PaymentResponseTypes based on criteria
     * @param body The search criteria
     * @return The search results of PaymentResponseTypes based on the criteria
     */
    searchPaymentResponseTypes(body: SearchRequestDTO_paymentResponseTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/paymentresponsetype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchPaymentResponseTypes(_response);
        });
    }

    protected processSearchPaymentResponseTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class PaymentStatusClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all PaymentStatuss
     * @return The list of PaymentStatuss
     */
    getPaymentStatuss( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/paymentstatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentStatuss(_response);
        });
    }

    protected processGetPaymentStatuss(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new PaymentStatus
     * @param body The PaymentStatus data to create
     * @return The newly created PaymentStatus data
     */
    createPaymentStatus(body: PaymentStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_paymentStatusDTO> {
        let url_ = this.baseUrl + "/paymentstatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePaymentStatus(_response);
        });
    }

    protected processCreatePaymentStatus(response: AxiosResponse): Promise<ApiResponse_paymentStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_paymentStatusDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_paymentStatusDTO>(null as any);
    }

    /**
     * Retrieve a PaymentStatus by ID
     * @param id The ID of the PaymentStatus to retrieve
     * @return The PaymentStatus data
     */
    getPaymentStatusById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_paymentStatusDTO> {
        let url_ = this.baseUrl + "/paymentstatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentStatusById(_response);
        });
    }

    protected processGetPaymentStatusById(response: AxiosResponse): Promise<ApiResponse_paymentStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_paymentStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_paymentStatusDTO>(null as any);
    }

    /**
     * Update a PaymentStatus by ID
     * @param id The ID of the PaymentStatus to update
     * @param body The updated PaymentStatus data
     * @return The updated PaymentStatus data
     */
    updatePaymentStatus(id: string, body: PaymentStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_paymentStatusDTO> {
        let url_ = this.baseUrl + "/paymentstatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePaymentStatus(_response);
        });
    }

    protected processUpdatePaymentStatus(response: AxiosResponse): Promise<ApiResponse_paymentStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_paymentStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_paymentStatusDTO>(null as any);
    }

    /**
     * Delete a PaymentStatus by ID
     * @param id The ID of the PaymentStatus to delete
     */
    deletePaymentStatus(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/paymentstatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePaymentStatus(_response);
        });
    }

    protected processDeletePaymentStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search PaymentStatuss based on criteria
     * @param body The search criteria
     * @return The search results of PaymentStatuss based on the criteria
     */
    searchPaymentStatuss(body: SearchRequestDTO_paymentStatusSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/paymentstatus/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchPaymentStatuss(_response);
        });
    }

    protected processSearchPaymentStatuss(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class QuestionSetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all QuestionSets
     * @return The list of QuestionSets
     */
    getQuestionSets( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/questionset";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuestionSets(_response);
        });
    }

    protected processGetQuestionSets(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new QuestionSet
     * @param body The QuestionSet data to create
     * @return The newly created QuestionSet data
     */
    createQuestionSet(body: QuestionSetDTO, cancelToken?: CancelToken): Promise<ApiResponse_questionSetDTO> {
        let url_ = this.baseUrl + "/questionset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateQuestionSet(_response);
        });
    }

    protected processCreateQuestionSet(response: AxiosResponse): Promise<ApiResponse_questionSetDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_questionSetDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_questionSetDTO>(null as any);
    }

    /**
     * Retrieve a QuestionSet by ID
     * @param id The ID of the QuestionSet to retrieve
     * @return The QuestionSet data
     */
    getQuestionSetById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_questionSetDTO> {
        let url_ = this.baseUrl + "/questionset/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuestionSetById(_response);
        });
    }

    protected processGetQuestionSetById(response: AxiosResponse): Promise<ApiResponse_questionSetDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_questionSetDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_questionSetDTO>(null as any);
    }

    /**
     * Update a QuestionSet by ID
     * @param id The ID of the QuestionSet to update
     * @param body The updated QuestionSet data
     * @return The updated QuestionSet data
     */
    updateQuestionSet(id: string, body: QuestionSetDTO, cancelToken?: CancelToken): Promise<ApiResponse_questionSetDTO> {
        let url_ = this.baseUrl + "/questionset/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateQuestionSet(_response);
        });
    }

    protected processUpdateQuestionSet(response: AxiosResponse): Promise<ApiResponse_questionSetDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_questionSetDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_questionSetDTO>(null as any);
    }

    /**
     * Delete a QuestionSet by ID
     * @param id The ID of the QuestionSet to delete
     */
    deleteQuestionSet(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/questionset/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteQuestionSet(_response);
        });
    }

    protected processDeleteQuestionSet(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search QuestionSets based on criteria
     * @param body The search criteria
     * @return The search results of QuestionSets based on the criteria
     */
    searchQuestionSets(body: SearchRequestDTO_questionSetSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/questionset/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchQuestionSets(_response);
        });
    }

    protected processSearchQuestionSets(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class QuestionSetItemAnswerClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all QuestionSetItemAnswers
     * @return The list of QuestionSetItemAnswers
     */
    getQuestionSetItemAnswers( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/questionsetitemanswer";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuestionSetItemAnswers(_response);
        });
    }

    protected processGetQuestionSetItemAnswers(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new QuestionSetItemAnswer
     * @param body The QuestionSetItemAnswer data to create
     * @return The newly created QuestionSetItemAnswer data
     */
    createQuestionSetItemAnswer(body: QuestionSetItemAnswerDTO, cancelToken?: CancelToken): Promise<ApiResponse_questionSetItemAnswerDTO> {
        let url_ = this.baseUrl + "/questionsetitemanswer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateQuestionSetItemAnswer(_response);
        });
    }

    protected processCreateQuestionSetItemAnswer(response: AxiosResponse): Promise<ApiResponse_questionSetItemAnswerDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_questionSetItemAnswerDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_questionSetItemAnswerDTO>(null as any);
    }

    /**
     * Retrieve a QuestionSetItemAnswer by ID
     * @param id The ID of the QuestionSetItemAnswer to retrieve
     * @return The QuestionSetItemAnswer data
     */
    getQuestionSetItemAnswerById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_questionSetItemAnswerDTO> {
        let url_ = this.baseUrl + "/questionsetitemanswer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuestionSetItemAnswerById(_response);
        });
    }

    protected processGetQuestionSetItemAnswerById(response: AxiosResponse): Promise<ApiResponse_questionSetItemAnswerDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_questionSetItemAnswerDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_questionSetItemAnswerDTO>(null as any);
    }

    /**
     * Update a QuestionSetItemAnswer by ID
     * @param id The ID of the QuestionSetItemAnswer to update
     * @param body The updated QuestionSetItemAnswer data
     * @return The updated QuestionSetItemAnswer data
     */
    updateQuestionSetItemAnswer(id: string, body: QuestionSetItemAnswerDTO, cancelToken?: CancelToken): Promise<ApiResponse_questionSetItemAnswerDTO> {
        let url_ = this.baseUrl + "/questionsetitemanswer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateQuestionSetItemAnswer(_response);
        });
    }

    protected processUpdateQuestionSetItemAnswer(response: AxiosResponse): Promise<ApiResponse_questionSetItemAnswerDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_questionSetItemAnswerDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_questionSetItemAnswerDTO>(null as any);
    }

    /**
     * Delete a QuestionSetItemAnswer by ID
     * @param id The ID of the QuestionSetItemAnswer to delete
     */
    deleteQuestionSetItemAnswer(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/questionsetitemanswer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteQuestionSetItemAnswer(_response);
        });
    }

    protected processDeleteQuestionSetItemAnswer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search QuestionSetItemAnswers based on criteria
     * @param body The search criteria
     * @return The search results of QuestionSetItemAnswers based on the criteria
     */
    searchQuestionSetItemAnswers(body: SearchRequestDTO_questionSetItemAnswerSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/questionsetitemanswer/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchQuestionSetItemAnswers(_response);
        });
    }

    protected processSearchQuestionSetItemAnswers(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class QuestionSetItemClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all QuestionSetItems
     * @return The list of QuestionSetItems
     */
    getQuestionSetItems( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/questionsetitem";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuestionSetItems(_response);
        });
    }

    protected processGetQuestionSetItems(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new QuestionSetItem
     * @param body The QuestionSetItem data to create
     * @return The newly created QuestionSetItem data
     */
    createQuestionSetItem(body: QuestionSetItemDTO, cancelToken?: CancelToken): Promise<ApiResponse_questionSetItemDTO> {
        let url_ = this.baseUrl + "/questionsetitem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateQuestionSetItem(_response);
        });
    }

    protected processCreateQuestionSetItem(response: AxiosResponse): Promise<ApiResponse_questionSetItemDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_questionSetItemDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_questionSetItemDTO>(null as any);
    }

    /**
     * Retrieve a QuestionSetItem by ID
     * @param id The ID of the QuestionSetItem to retrieve
     * @return The QuestionSetItem data
     */
    getQuestionSetItemById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_questionSetItemDTO> {
        let url_ = this.baseUrl + "/questionsetitem/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuestionSetItemById(_response);
        });
    }

    protected processGetQuestionSetItemById(response: AxiosResponse): Promise<ApiResponse_questionSetItemDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_questionSetItemDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_questionSetItemDTO>(null as any);
    }

    /**
     * Update a QuestionSetItem by ID
     * @param id The ID of the QuestionSetItem to update
     * @param body The updated QuestionSetItem data
     * @return The updated QuestionSetItem data
     */
    updateQuestionSetItem(id: string, body: QuestionSetItemDTO, cancelToken?: CancelToken): Promise<ApiResponse_questionSetItemDTO> {
        let url_ = this.baseUrl + "/questionsetitem/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateQuestionSetItem(_response);
        });
    }

    protected processUpdateQuestionSetItem(response: AxiosResponse): Promise<ApiResponse_questionSetItemDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_questionSetItemDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_questionSetItemDTO>(null as any);
    }

    /**
     * Delete a QuestionSetItem by ID
     * @param id The ID of the QuestionSetItem to delete
     */
    deleteQuestionSetItem(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/questionsetitem/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteQuestionSetItem(_response);
        });
    }

    protected processDeleteQuestionSetItem(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search QuestionSetItems based on criteria
     * @param body The search criteria
     * @return The search results of QuestionSetItems based on the criteria
     */
    searchQuestionSetItems(body: SearchRequestDTO_questionSetItemSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/questionsetitem/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchQuestionSetItems(_response);
        });
    }

    protected processSearchQuestionSetItems(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class QuestionSetItemTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all QuestionSetItemTypes
     * @return The list of QuestionSetItemTypes
     */
    getQuestionSetItemTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/questionsetitemtype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuestionSetItemTypes(_response);
        });
    }

    protected processGetQuestionSetItemTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new QuestionSetItemType
     * @param body The QuestionSetItemType data to create
     * @return The newly created QuestionSetItemType data
     */
    createQuestionSetItemType(body: QuestionSetItemTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_questionSetItemTypeDTO> {
        let url_ = this.baseUrl + "/questionsetitemtype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateQuestionSetItemType(_response);
        });
    }

    protected processCreateQuestionSetItemType(response: AxiosResponse): Promise<ApiResponse_questionSetItemTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_questionSetItemTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_questionSetItemTypeDTO>(null as any);
    }

    /**
     * Retrieve a QuestionSetItemType by ID
     * @param id The ID of the QuestionSetItemType to retrieve
     * @return The QuestionSetItemType data
     */
    getQuestionSetItemTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_questionSetItemTypeDTO> {
        let url_ = this.baseUrl + "/questionsetitemtype/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuestionSetItemTypeById(_response);
        });
    }

    protected processGetQuestionSetItemTypeById(response: AxiosResponse): Promise<ApiResponse_questionSetItemTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_questionSetItemTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_questionSetItemTypeDTO>(null as any);
    }

    /**
     * Update a QuestionSetItemType by ID
     * @param id The ID of the QuestionSetItemType to update
     * @param body The updated QuestionSetItemType data
     * @return The updated QuestionSetItemType data
     */
    updateQuestionSetItemType(id: string, body: QuestionSetItemTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_questionSetItemTypeDTO> {
        let url_ = this.baseUrl + "/questionsetitemtype/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateQuestionSetItemType(_response);
        });
    }

    protected processUpdateQuestionSetItemType(response: AxiosResponse): Promise<ApiResponse_questionSetItemTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_questionSetItemTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_questionSetItemTypeDTO>(null as any);
    }

    /**
     * Delete a QuestionSetItemType by ID
     * @param id The ID of the QuestionSetItemType to delete
     */
    deleteQuestionSetItemType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/questionsetitemtype/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteQuestionSetItemType(_response);
        });
    }

    protected processDeleteQuestionSetItemType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search QuestionSetItemTypes based on criteria
     * @param body The search criteria
     * @return The search results of QuestionSetItemTypes based on the criteria
     */
    searchQuestionSetItemTypes(body: SearchRequestDTO_questionSetItemTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/questionsetitemtype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchQuestionSetItemTypes(_response);
        });
    }

    protected processSearchQuestionSetItemTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class RewardClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Rewards
     * @return The list of Rewards
     */
    getRewards( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/reward";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRewards(_response);
        });
    }

    protected processGetRewards(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Reward
     * @param body The Reward data to create
     * @return The newly created Reward data
     */
    createReward(body: RewardDTO, cancelToken?: CancelToken): Promise<ApiResponse_rewardDTO> {
        let url_ = this.baseUrl + "/reward";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateReward(_response);
        });
    }

    protected processCreateReward(response: AxiosResponse): Promise<ApiResponse_rewardDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_rewardDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rewardDTO>(null as any);
    }

    /**
     * Retrieve a Reward by ID
     * @param id The ID of the Reward to retrieve
     * @return The Reward data
     */
    getRewardById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_rewardDTO> {
        let url_ = this.baseUrl + "/reward/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRewardById(_response);
        });
    }

    protected processGetRewardById(response: AxiosResponse): Promise<ApiResponse_rewardDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_rewardDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rewardDTO>(null as any);
    }

    /**
     * Update a Reward by ID
     * @param id The ID of the Reward to update
     * @param body The updated Reward data
     * @return The updated Reward data
     */
    updateReward(id: string, body: RewardDTO, cancelToken?: CancelToken): Promise<ApiResponse_rewardDTO> {
        let url_ = this.baseUrl + "/reward/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateReward(_response);
        });
    }

    protected processUpdateReward(response: AxiosResponse): Promise<ApiResponse_rewardDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_rewardDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rewardDTO>(null as any);
    }

    /**
     * Delete a Reward by ID
     * @param id The ID of the Reward to delete
     */
    deleteReward(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/reward/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteReward(_response);
        });
    }

    protected processDeleteReward(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Rewards based on criteria
     * @param body The search criteria
     * @return The search results of Rewards based on the criteria
     */
    searchRewards(body: SearchRequestDTO_rewardSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/reward/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchRewards(_response);
        });
    }

    protected processSearchRewards(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class AuditLogClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve an audit log by ID
     * @param id The ID of the audit log to retrieve
     * @return The audit log data
     */
    getAuditLogById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_auditLogDTO> {
        let url_ = this.baseUrl + "/auditlogs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditLogById(_response);
        });
    }

    protected processGetAuditLogById(response: AxiosResponse): Promise<ApiResponse_auditLogDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_auditLogDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_auditLogDTO>(null as any);
    }

    /**
     * Search audit logs based on criteria
     * @param body The search criteria
     * @return The search results of audit logs based on the criteria
     */
    searchAuditLogs(body: SearchRequestDTO_auditLogSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/auditlogs/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchAuditLogs(_response);
        });
    }

    protected processSearchAuditLogs(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Retrieve distinct table names
     * @return The list of distinct table names
     */
    getDistinctTableNames( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/auditlogs/tablenames";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDistinctTableNames(_response);
        });
    }

    protected processGetDistinctTableNames(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }
}

export class AuthClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Generates a token for user authentication
     * @param body User credentials for token generation
     * @return JWT token for authenticated requests
     */
    generateToken(body: LoginUserDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/token/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateToken(_response);
        });
    }

    protected processGenerateToken(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, incorrect email or password.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generates a token for user authentication via two factor authentication
     * @param body Two factor auth data for token generation
     * @return JWT token for authenticated requests
     */
    generateTokenTwoFactor(body: LoginTwoFactorDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/token/twofactor/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateTokenTwoFactor(_response);
        });
    }

    protected processGenerateTokenTwoFactor(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, incorrect credentials.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Refreshes an access token
     * @param body Payload containing the refresh token
     * @return The refreshed access token, refresh token, and expiration time.
     */
    refreshToken(body: RefreshTokenDTO, cancelToken?: CancelToken): Promise<ApiResponse_authDTO> {
        let url_ = this.baseUrl + "/auth/token/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<ApiResponse_authDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_authDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request in case of invalid refresh token.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized if the refresh token is expired or invalid.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_authDTO>(null as any);
    }

    /**
     * Setup Two-Factor Authentication
     * @param userId The ID of the user
     * @return TOTP setup details including QR code and secret
     */
    setupTwoFactor(userId: string, cancelToken?: CancelToken): Promise<ApiResponse_twoFactorSetupResponseDTO> {
        let url_ = this.baseUrl + "/auth/{userId}/two-factor/setup";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetupTwoFactor(_response);
        });
    }

    protected processSetupTwoFactor(response: AxiosResponse): Promise<ApiResponse_twoFactorSetupResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_twoFactorSetupResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("User not found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_twoFactorSetupResponseDTO>(null as any);
    }

    /**
     * Verify Two-Factor Authentication Code
     * @param body Payload containing the TOTP code and user ID.
     * @return Verification success message.
     */
    verifyTwoFactor(body: VerifyTwoFactorDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/two-factor/verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyTwoFactor(_response);
        });
    }

    protected processVerifyTwoFactor(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad request if the payload is invalid.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized if the TOTP code is invalid.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Validates a Google sign in token and returns JWT token
     * @param body Google sign in token
     * @return JWT token for authenticated requests
     */
    googleTokenExchange(body: TokenExchangeDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/tokenexchange/google";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGoogleTokenExchange(_response);
        });
    }

    protected processGoogleTokenExchange(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, invalid Google sign in token", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generates a token for an admin when impersonating a member
     * @param body User credentials for token generation
     * @return JWT token for authenticated requests
     */
    impersonateMemberLogin(body: ImpersonationDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/impersonate/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImpersonateMemberLogin(_response);
        });
    }

    protected processImpersonateMemberLogin(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, incorrect email or password.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generates a token for an admin when loggin out of a member
     * @param body User credentials for token generation
     * @return JWT token for authenticated requests
     */
    impersonateMemberLogout(body: ImpersonationDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/impersonate/logout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImpersonateMemberLogout(_response);
        });
    }

    protected processImpersonateMemberLogout(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, incorrect email or password.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class BulkEmailClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all bulk email statuses.
     * @return List of bulk email statuses.
     */
    getAllBulkEmailStatuses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/bulkemails/statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBulkEmailStatuses(_response);
        });
    }

    protected processGetAllBulkEmailStatuses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Process a bulk email
     * @param id The ID of the bulk email to process
     * @return The processed bulk email data
     */
    processBulkEmail(id: string, cancelToken?: CancelToken): Promise<ApiResponse_bulkEmailDTO> {
        let url_ = this.baseUrl + "/bulkemails/{id}/process";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessBulkEmail(_response);
        });
    }

    protected processProcessBulkEmail(response: AxiosResponse): Promise<ApiResponse_bulkEmailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_bulkEmailDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad request response if processing fails", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Server error response", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bulkEmailDTO>(null as any);
    }

    /**
     * Retrieve all bulk emails
     * @return The list of bulk emails
     */
    getBulkEmails( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/bulkemails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBulkEmails(_response);
        });
    }

    protected processGetBulkEmails(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new bulk email
     * @param body The bulk email data to create
     * @return The newly created bulk email data
     */
    createBulkEmail(body: BulkEmailDTO, cancelToken?: CancelToken): Promise<ApiResponse_bulkEmailDTO> {
        let url_ = this.baseUrl + "/bulkemails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBulkEmail(_response);
        });
    }

    protected processCreateBulkEmail(response: AxiosResponse): Promise<ApiResponse_bulkEmailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_bulkEmailDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bulkEmailDTO>(null as any);
    }

    /**
     * Retrieve a bulk email by ID
     * @param id The ID of the bulk email to retrieve
     * @return The bulk email data
     */
    getBulkEmailById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_bulkEmailDTO> {
        let url_ = this.baseUrl + "/bulkemails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBulkEmailById(_response);
        });
    }

    protected processGetBulkEmailById(response: AxiosResponse): Promise<ApiResponse_bulkEmailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_bulkEmailDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bulkEmailDTO>(null as any);
    }

    /**
     * Update a bulk email by ID
     * @param id The ID of the bulk email to update
     * @param body The updated bulk email data
     * @return The updated bulk email data
     */
    updateBulkEmail(id: string, body: BulkEmailDTO, cancelToken?: CancelToken): Promise<ApiResponse_bulkEmailDTO> {
        let url_ = this.baseUrl + "/bulkemails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBulkEmail(_response);
        });
    }

    protected processUpdateBulkEmail(response: AxiosResponse): Promise<ApiResponse_bulkEmailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_bulkEmailDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bulkEmailDTO>(null as any);
    }

    /**
     * Delete a bulk email by ID
     * @param id The ID of the bulk email to delete
     */
    deleteBulkEmail(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/bulkemails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBulkEmail(_response);
        });
    }

    protected processDeleteBulkEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Upload a bulk email attachment
     * @param fileName (optional) Optional file name for saving the file. If not provided, a unique name will be generated.
     * @param body The raw file content to upload
     * @return The relative path of the uploaded file
     */
    uploadBulkEmailAttachment(fileName: string | null | undefined, body: Blob, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/bulkemails/attachments/upload?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/octet-stream",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadBulkEmailAttachment(_response);
        });
    }

    protected processUploadBulkEmailAttachment(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request: Invalid file or missing parameters.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("An error occurred while uploading the file.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Search bulk emails based on criteria
     * @param body The search criteria
     * @return The search results of bulk emails based on the criteria
     */
    searchBulkEmails(body: SearchRequestDTO_bulkEmailSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/bulkemails/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchBulkEmails(_response);
        });
    }

    protected processSearchBulkEmails(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class CommunicationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Unsubscribe an email using a token.
     * @param body Token data for unsubscribing an email.
     * @return Result of the unsubscribe action.
     */
    unsubscribeEmail(body: UnsubscribedEmailRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/communication/unsubscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnsubscribeEmail(_response);
        });
    }

    protected processUnsubscribeEmail(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Retrieve all unsubscribed emails.
     * @return List of unsubscribed emails.
     */
    getAllUnsubscribedEmails( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/communication/unsubscribed-emails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUnsubscribedEmails(_response);
        });
    }

    protected processGetAllUnsubscribedEmails(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Retrieve all communication lists.
     * @return List of communication lists.
     */
    getAllCommunicationLists( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/communication/lists";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllCommunicationLists(_response);
        });
    }

    protected processGetAllCommunicationLists(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }
}

export class CompanyInfoClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all company infos
     * @return The list of company infos
     */
    getCompanyInfos( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/companyinfos";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompanyInfos(_response);
        });
    }

    protected processGetCompanyInfos(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new company info
     * @param body The company info data to create
     * @return The newly created data.
     */
    createCompanyInfo(body: CompanyInfoDTO, cancelToken?: CancelToken): Promise<ApiResponse_companyInfoDTO> {
        let url_ = this.baseUrl + "/companyinfos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCompanyInfo(_response);
        });
    }

    protected processCreateCompanyInfo(response: AxiosResponse): Promise<ApiResponse_companyInfoDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_companyInfoDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_companyInfoDTO>(null as any);
    }

    /**
     * Retrieve a company info by ID
     * @param id The ID of the company info to retrieve
     * @return The company info data
     */
    getCompanyInfoById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_companyInfoDTO> {
        let url_ = this.baseUrl + "/companyinfos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompanyInfoById(_response);
        });
    }

    protected processGetCompanyInfoById(response: AxiosResponse): Promise<ApiResponse_companyInfoDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_companyInfoDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_companyInfoDTO>(null as any);
    }

    /**
     * Update a company info by ID
     * @param id The ID of the company info to update
     * @param body The updated company info data
     * @return The updated company info data.
     */
    updateCompanyInfo(id: string, body: CompanyInfoDTO, cancelToken?: CancelToken): Promise<ApiResponse_companyInfoDTO> {
        let url_ = this.baseUrl + "/companyinfos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCompanyInfo(_response);
        });
    }

    protected processUpdateCompanyInfo(response: AxiosResponse): Promise<ApiResponse_companyInfoDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_companyInfoDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_companyInfoDTO>(null as any);
    }

    /**
     * Delete a company info by ID
     * @param id The ID of the company info to delete
     */
    deleteCompanyInfo(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/companyinfos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCompanyInfo(_response);
        });
    }

    protected processDeleteCompanyInfo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search company infos based on criteria
     * @param body The search criteria
     * @return The search results of company info based on the criteria
     */
    searchCompanyInfos(body: SearchRequestDTO_companyInfoSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/companyinfos/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCompanyInfos(_response);
        });
    }

    protected processSearchCompanyInfos(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class MemberClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Members
     * @return The list of members
     */
    getMembers( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/member";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMembers(_response);
        });
    }

    protected processGetMembers(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Member
     * @param body The Member data to create
     * @return The newly created Member data
     */
    createMember(body: MemberDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberDTO> {
        let url_ = this.baseUrl + "/member";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMember(_response);
        });
    }

    protected processCreateMember(response: AxiosResponse): Promise<ApiResponse_memberDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberDTO>(null as any);
    }

    /**
     * Retrieve a Member by ID
     * @param id The ID of the Member to retrieve
     * @return The Member data
     */
    getMemberById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberDTO> {
        let url_ = this.baseUrl + "/member/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberById(_response);
        });
    }

    protected processGetMemberById(response: AxiosResponse): Promise<ApiResponse_memberDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberDTO>(null as any);
    }

    /**
     * Update a Member by ID
     * @param id The ID of the Member to update
     * @param body The updated Member data
     * @return The updated Member data
     */
    updateMember(id: string, body: MemberDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberDTO> {
        let url_ = this.baseUrl + "/member/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMember(_response);
        });
    }

    protected processUpdateMember(response: AxiosResponse): Promise<ApiResponse_memberDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberDTO>(null as any);
    }

    /**
     * Delete a Member by ID
     * @param id The ID of the Member to delete
     */
    deleteMember(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/member/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMember(_response);
        });
    }

    protected processDeleteMember(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Members based on criteria
     * @param body The search criteria
     * @return The search results of Members based on the criteria
     */
    searchMembers(body: SearchRequestDTO_memberSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/member/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMembers(_response);
        });
    }

    protected processSearchMembers(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Retrieve a Member by Email
     * @param email The email of the Member to retrieve
     * @return The Member data
     */
    getMemberByEmail(email: string, cancelToken?: CancelToken): Promise<ApiResponse_memberDTO> {
        let url_ = this.baseUrl + "/member/by-email/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberByEmail(_response);
        });
    }

    protected processGetMemberByEmail(response: AxiosResponse): Promise<ApiResponse_memberDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberDTO>(null as any);
    }
}

export class UserClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Checks if an email exists.
     * @param email The email address.
     * @return Payload of ApiResponse containing Boolean
     */
    checkEmailExists(email: string, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/users/check-email?";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckEmailExists(_response);
        });
    }

    protected processCheckEmailExists(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Get a user by ID
     * @param id The ID of the user to fetch
     * @return Payload of ApiResponse containing UserDTO
     */
    getUserById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_userDTO> {
        let url_ = this.baseUrl + "/user/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserById(_response);
        });
    }

    protected processGetUserById(response: AxiosResponse): Promise<ApiResponse_userDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_userDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("User not found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_userDTO>(null as any);
    }

    /**
     * Update an existing user
     * @return Payload of ApiResponse containing UserEditDTO
     */
    updateUser(id: string, body: UserEditDTO, cancelToken?: CancelToken): Promise<ApiResponse_userEditDTO> {
        let url_ = this.baseUrl + "/user/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: AxiosResponse): Promise<ApiResponse_userEditDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_userEditDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_userEditDTO>(null as any);
    }

    /**
     * Search for users
     * @return Payload of ApiResponse containing SearchResponseDTO<UserDTO>
     */
    searchUsers(body: SearchRequestDTO_userSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/user/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchUsers(_response);
        });
    }

    protected processSearchUsers(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Create a new user
     * @return Payload of ApiResponse containing UserDTO
     */
    createUser(body: UserCreateDTO, cancelToken?: CancelToken): Promise<ApiResponse_userDTO> {
        let url_ = this.baseUrl + "/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: AxiosResponse): Promise<ApiResponse_userDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_userDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_userDTO>(null as any);
    }

    /**
     * Generates a password reset link
     * @return Payload of ApiResponse containing String
     */
    forgotPassword(body: ForgotPasswordDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/user/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Resets a user's password using a reset token
     * @return Payload of ApiResponse containing String
     */
    resetPassword(body: ResetPasswordDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/user/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Uploads a users profile picture.
     * @param fileName (optional) The file name to use when saving the image
     * @param body The raw image file to upload
     * @return The URL of the uploaded image
     */
    uploadProfilePicture(fileName: string | null | undefined, body: Blob, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/user/upload-profile-picture?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/octet-stream",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadProfilePicture(_response);
        });
    }

    protected processUploadProfilePicture(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generates a SAS token for a user's profile picture.
     * @param userId The ID of the user.
     * @return The SAS URL for the profile picture.
     */
    generateProfilePictureSas(userId: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/users/{userId}/profile-picture";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateProfilePictureSas(_response);
        });
    }

    protected processGenerateProfilePictureSas(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export interface ApiResponse_auditLogDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: AuditLogDTO | undefined;
}

export interface ApiResponse_authDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: AuthDTO | undefined;
}

export interface ApiResponse_bankDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: BankDTO | undefined;
}

export interface ApiResponse_batchFileLogDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: BatchFileLogDTO | undefined;
}

export interface ApiResponse_boolean {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: boolean | undefined;
}

export interface ApiResponse_bulkEmailDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: BulkEmailDTO | undefined;
}

export interface ApiResponse_campaignDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CampaignDTO | undefined;
}

export interface ApiResponse_companyInfoDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CompanyInfoDTO | undefined;
}

export interface ApiResponse_donationOptionDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: DonationOptionDTO | undefined;
}

export interface ApiResponse_iEnumerable_1 {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: BankDTO[] | undefined;
}

export interface ApiResponse_memberDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberDTO | undefined;
}

export interface ApiResponse_paymentDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: PaymentDTO | undefined;
}

export interface ApiResponse_paymentResponseDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: PaymentResponseDTO | undefined;
}

export interface ApiResponse_paymentResponseTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: PaymentResponseTypeDTO | undefined;
}

export interface ApiResponse_paymentStatusDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: PaymentStatusDTO | undefined;
}

export interface ApiResponse_questionSetDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: QuestionSetDTO | undefined;
}

export interface ApiResponse_questionSetItemAnswerDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: QuestionSetItemAnswerDTO | undefined;
}

export interface ApiResponse_questionSetItemDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: QuestionSetItemDTO | undefined;
}

export interface ApiResponse_questionSetItemTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: QuestionSetItemTypeDTO | undefined;
}

export interface ApiResponse_rewardDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: RewardDTO | undefined;
}

export interface ApiResponse_searchResponseDTO_1 {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: SearchResponseDTO_bankDTO | undefined;
}

export interface ApiResponse_string {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: string | undefined;
}

export interface ApiResponse_twoFactorSetupResponseDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: TwoFactorSetupResponseDTO | undefined;
}

export interface ApiResponse_userDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: UserDTO | undefined;
}

export interface ApiResponse_userEditDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: UserEditDTO | undefined;
}

export interface AuditLogDTO {
    action?: string | undefined;
    tableName?: string | undefined;
    recordId?: string | undefined;
    propertyName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    createdUtc?: string | undefined;
    updatedUtc?: string | undefined;
    changedBy?: string | undefined;
}

export interface AuditLogSearchRequestDTO {
    tableName?: string | undefined;
    recordId?: string | undefined;
    dateStart?: Date | undefined;
    dateEnd?: Date | undefined;
}

export interface AuthDTO {
    accessToken?: string | undefined;
    expiresAt?: number | undefined;
    refreshToken?: string | undefined;
    twoFactorEnabled?: boolean | undefined;
}

export interface BankDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    name?: string | undefined;
    branchCode?: string | undefined;
}

export interface BankSearchRequestDTO {
    name?: string | undefined;
    branchCode?: string | undefined;
}

export interface BatchFileLogDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    memberId?: string | undefined;
    fileToken?: string | undefined;
    mandateFilePath?: string | undefined;
}

export interface BatchFileLogSearchRequestDTO {
    memberId?: string | undefined;
    fileToken?: string | undefined;
}

export interface BulkEmailDTO {
    id?: string | undefined;
    subject?: string | undefined;
    title?: string | undefined;
    content?: string | undefined;
    bulkEmailStatusId?: string | undefined;
    communicationListId?: string | undefined;
    totalCount?: number | undefined;
    totalCountProcessed?: number | undefined;
    attachmentPath?: string | undefined;
    bulkEmailStatusName?: string | undefined;
    communicationListName?: string | undefined;
}

export interface BulkEmailSearchRequestDTO {
    subject?: string | undefined;
}

export interface CampaignDTO {
    id?: string | undefined;
    name?: string | undefined;
    fileName?: string | undefined;
    questionSetId?: string | undefined;
    debitOnly?: boolean | undefined;
    createdUtc?: Date | undefined;
}

export interface CampaignSearchRequestDTO {
    name?: string | undefined;
    fileName?: string | undefined;
    questionSetId?: string | undefined;
}

export interface CompanyInfoDTO {
    id?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    bank?: string | undefined;
    accountType?: string | undefined;
    branchCode?: string | undefined;
    accountNumber?: string | undefined;
    swiftCode?: string | undefined;
    notes?: string | undefined;
    lastUsedInvoiceNumber?: number | undefined;
}

export interface CompanyInfoSearchRequestDTO {
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    bank?: string | undefined;
    accountType?: string | undefined;
    branchCode?: string | undefined;
    accountNumber?: string | undefined;
    swiftCode?: string | undefined;
    notes?: string | undefined;
    lastUsedInvoiceNumber?: number | undefined;
}

export interface DebitOrderMandateDTO {
    memberId?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    bankName?: string | undefined;
    accountHolder?: string | undefined;
    accountNumber?: string | undefined;
    branchCode?: string | undefined;
    accountType?: string | undefined;
    idNumber?: string | undefined;
    donation?: DonationDTO | undefined;
    signatureImage?: string | undefined;
    signedAt?: string | undefined;
}

export interface DonationDTO {
    amount?: number | undefined;
    frequency?: string | undefined;
    dayOfMonth?: number | undefined;
}

export interface DonationOptionDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    name?: string | undefined;
}

export interface DonationOptionSearchRequestDTO {
    name?: string | undefined;
}

export interface ForgotPasswordDTO {
    email: string;
}

export interface ImpersonationDTO {
    memberId?: string | undefined;
    adminId?: string | undefined;
}

export interface LoginTwoFactorDTO {
    email?: string | undefined;
    tempToken?: string | undefined;
    code?: string | undefined;
}

export interface LoginUserDTO {
    email: string;
    password: string;
}

export interface MemberDTO {
    id?: string | undefined;
    membershipNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    userID?: string | undefined;
    isDebitOrder?: boolean | undefined;
    mandateFilePath?: string | undefined;
}

export interface MemberSearchRequestDTO {
    membershipNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    isDebitOrder?: boolean | undefined;
}

export interface PaymentDTO {
    id?: string | undefined;
    paymentStatusId?: string | undefined;
    memberId?: string | undefined;
    campaignId?: string | undefined;
    amount?: number | undefined;
    subscription?: boolean | undefined;
    debitDay?: number | undefined;
    campaignName?: string | undefined;
    paymentStatusName?: string | undefined;
    memberName?: string | undefined;
    memberEmail?: string | undefined;
    createdUtc?: Date | undefined;
}

export interface PaymentResponseDTO {
    id?: string | undefined;
    paymentId?: string | undefined;
    paymentResponseTypeId?: string | undefined;
    data?: string | undefined;
    paymentResponseTypeName?: string | undefined;
}

export interface PaymentResponseSearchRequestDTO {
    paymentId?: string | undefined;
    paymentResponseTypeId?: string | undefined;
    data?: string | undefined;
}

export interface PaymentResponseTypeDTO {
    id?: string | undefined;
    name?: string | undefined;
}

export interface PaymentResponseTypeSearchRequestDTO {
    name?: string | undefined;
}

export interface PaymentSearchRequestDTO {
    paymentStatusId?: string | undefined;
    memberId?: string | undefined;
    campaignId?: string | undefined;
    amount?: number | undefined;
}

export interface PaymentStatusDTO {
    id?: string | undefined;
    name?: string | undefined;
}

export interface PaymentStatusSearchRequestDTO {
    name?: string | undefined;
}

export interface QuestionSetDTO {
    id?: string | undefined;
    name?: string | undefined;
    createdUtc?: Date | undefined;
}

export interface QuestionSetItemAnswerDTO {
    id?: string | undefined;
    questionSetItemId?: string | undefined;
    answer?: string | undefined;
    memberId?: string | undefined;
    campaignId?: string | undefined;
}

export interface QuestionSetItemAnswerSearchRequestDTO {
    questionSetItemId?: string | undefined;
    answer?: string | undefined;
    memberId?: string | undefined;
    campaignId?: string | undefined;
}

export interface QuestionSetItemDTO {
    id?: string | undefined;
    questionSetId?: string | undefined;
    questionSetItemTypeId?: string | undefined;
    question?: string | undefined;
    data?: string | undefined;
    orderSequence?: number | undefined;
    questionSetItemTypeName?: string | undefined;
}

export interface QuestionSetItemSearchRequestDTO {
    questionSetId?: string | undefined;
    questionSetItemTypeId?: string | undefined;
    question?: string | undefined;
    data?: string | undefined;
    orderSequence?: number | undefined;
}

export interface QuestionSetItemTypeDTO {
    id?: string | undefined;
    name?: string | undefined;
}

export interface QuestionSetItemTypeSearchRequestDTO {
    name?: string | undefined;
}

export interface QuestionSetSearchRequestDTO {
    name?: string | undefined;
}

export interface RefreshTokenDTO {
    refreshToken?: string | undefined;
}

export interface ResetPasswordDTO {
    email?: string | undefined;
    token?: string | undefined;
    newPassword?: string | undefined;
}

export interface RewardDTO {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    startRange?: number | undefined;
    endRange?: number | undefined;
    createdUtc?: Date | undefined;
}

export interface RewardSearchRequestDTO {
    name?: string | undefined;
    description?: string | undefined;
    startRange?: number | undefined;
    endRange?: number | undefined;
}

export interface SearchRequestDTO_auditLogSearchRequestDTO {
    filters?: AuditLogSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_bankSearchRequestDTO {
    filters?: BankSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_batchFileLogSearchRequestDTO {
    filters?: BatchFileLogSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_bulkEmailSearchRequestDTO {
    filters?: BulkEmailSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_campaignSearchRequestDTO {
    filters?: CampaignSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_companyInfoSearchRequestDTO {
    filters?: CompanyInfoSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_donationOptionSearchRequestDTO {
    filters?: DonationOptionSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberSearchRequestDTO {
    filters?: MemberSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_paymentResponseSearchRequestDTO {
    filters?: PaymentResponseSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_paymentResponseTypeSearchRequestDTO {
    filters?: PaymentResponseTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_paymentSearchRequestDTO {
    filters?: PaymentSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_paymentStatusSearchRequestDTO {
    filters?: PaymentStatusSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_questionSetItemAnswerSearchRequestDTO {
    filters?: QuestionSetItemAnswerSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_questionSetItemSearchRequestDTO {
    filters?: QuestionSetItemSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_questionSetItemTypeSearchRequestDTO {
    filters?: QuestionSetItemTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_questionSetSearchRequestDTO {
    filters?: QuestionSetSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_rewardSearchRequestDTO {
    filters?: RewardSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_userSearchRequestDTO {
    filters?: UserSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchResponseDTO_bankDTO {
    results?: BankDTO[] | undefined;
    totalCount?: number | undefined;
}

export interface TokenExchangeDTO {
    token?: string | undefined;
}

export interface TwoFactorSetupResponseDTO {
    qrCodeUrl?: string | undefined;
}

export interface UnsubscribedEmailRequestDTO {
    token?: string | undefined;
    reason?: string | undefined;
}

export interface UserCreateDTO {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    phoneNumber?: string | undefined;
    profilePicture?: string | undefined;
}

export interface UserDTO {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    profilePicture?: string | undefined;
    twoFactorEnabled?: boolean | undefined;
    createdUtc?: Date | undefined;
}

export interface UserEditDTO {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    profilePicture?: string | undefined;
    twoFactorEnabled?: boolean | undefined;
}

export interface UserSearchRequestDTO {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    role?: string | undefined;
}

export interface VerifyTwoFactorDTO {
    userId?: string | undefined;
    code?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}